import * as React from "react";
import { useContext, useState } from "react";

interface Sidebar {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SidebarContext = React.createContext<Sidebar | null>(null);

export const SidebarStateProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <SidebarContext.Provider
      value={{
        open: sidebarOpen,
        setOpen: setSidebarOpen,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export function useSidebarContext(): Sidebar {
  const context = useContext(SidebarContext);

  if (!context) {
    throw new Error("Missing SidebarStateProvider");
  }

  return context;
}
